import { render, staticRenderFns } from "./Winners.vue?vue&type=template&id=6a223d74"
import script from "./Winners.js?vue&type=script&lang=js&external"
export * from "./Winners.js?vue&type=script&lang=js&external"
import style0 from "./Winners.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports